<div class="mp-hour-picker {{ size }} {{ customClasses }}"
  [class.disabled]="disabled"
  [class.without-value]="!hourValue"
  [class.isInvalid]="isInvalid">
  @if (label) {
    <label class="mp-hour-picker-label">{{ label | translate }}</label>
  }
  <div class="mp-hour-picker-wrapper">
    <input class="mp-hour-input" [class.without-label]="!label"
      [readonly]="disabled"
      [(ngModel)]="hourValue" (blur)="onHourPickerBlur()">
    </div>
  </div>
